import apiCall from '../../../utility/api';
import { getGroupsListCnt } from './remediation_common_func';

type dataProps = {
  setExportBtnClicked?: any;
  exportBtnClicked?: any;
  data: any;
  func: any;
  searchVal?: any;
  pageNo: any;
  setTotalPages?: any;
  setTotalRecords?: any;
  isRefresh: any;
  setRefresh: any;
  setRefreshToast?: any;
  setPolicyPatch?: any;
  policyPatch?: any;
  saveBtnClicked?: boolean;
  setGroupDeviceCnt?: any;
  groupDeviceCnt?: any;
  setPreviousSelectedGroups?: any;
  tenant?: any;
  setDeviceCnt?: any;
  setExportDetails?: any;
  setSaveBtnClicked?: any;
  userActivity?: any;
  dartNo?: any;
  automationName?: any;
  automationType?: any;
  automationId?: any;
}

const Remediations_func = (props: dataProps) => {
  let policyid = sessionStorage.getItem('policyid');

  const groupsAttachedToRemediation = async (whereCondition: any, limit: number | null = null, offset: number | null = null) => {
    try {
      const { status, data } = await apiCall('/automation/getList', whereCondition);

      if (status === 'success') {
        var attachedConfigGroups: any = data[0].status;

        if (attachedConfigGroups !== 'not attached') {
          attachedConfigGroups = attachedConfigGroups?.split("|").filter((val: any) => val.includes(`${props.tenant}:`));

          if (attachedConfigGroups?.length > 0) {
            attachedConfigGroups = attachedConfigGroups[0]?.split(":")[1];

            if (attachedConfigGroups.startsWith('all')) {
              props.setPreviousSelectedGroups(['All Devices']);
            } else {
              props.setPreviousSelectedGroups(attachedConfigGroups.split(","));
            }
          } else {
            props.setPreviousSelectedGroups([]);
          }
        } else {
          props.setPreviousSelectedGroups([]);
        }
      }
    } catch (error) {
      console.log("groupsAttachedToRemediation error=", error);
      props.setPreviousSelectedGroups([]);
    }
  }

  const getAppMonitoredList = async (whereCondition: any, limit: any, offset: any) => {
    try {
      const { status, data } = await apiCall('/appmonitored/getAppMonitoredList', { ...whereCondition, limit, offset });
      console.log("statusapp==", status);

      if (status === 'success') {
        var attachedConfigGroups: any = data[0].status;

        if (attachedConfigGroups !== 'not attached') {
          attachedConfigGroups = attachedConfigGroups?.split("|").filter((val: any) => val.includes(`${props.tenant}:`));

          if (attachedConfigGroups?.length > 0) {
            attachedConfigGroups = attachedConfigGroups[0]?.split(":")[1];

            if (attachedConfigGroups.startsWith('all')) {
              props.setPreviousSelectedGroups(['All Devices']);
            } else {
              props.setPreviousSelectedGroups(attachedConfigGroups.split(","));
            }
          } else {
            props.setPreviousSelectedGroups([]);
          }
        } else {
          props.setPreviousSelectedGroups([]);
        }
      }
    } catch (error) {
      console.log("groupsAttachedToRemediation error=", error);
      props.setPreviousSelectedGroups([]);
    }
  }

  const getGroupsList = async (whereCondition: object, limit: number | null, offset: number | null) => {
    try {
      let type;
      if (props.automationType === 'usersurvey') {
        type = 'userSurvey';
      } else {
        type = props.automationType;
      }

      props.automationType === "data_collection" ? await getAppMonitoredList({ id: props.automationId }, null, null) : await groupsAttachedToRemediation({ types: type, automationName: props.automationName, dartid: props.dartNo });

      await getTenantDevicesCnt({ tenant: props.tenant });

      const { status, data } = await apiCall('/groups/getList', { ...whereCondition, limit, offset });

      if (status === 'success' && data?.length > 0) {
        data.map(async (val: any, i: any) => {
          await getGroupedDeviceCnt({ tenant: props.tenant, classification: val.classificationName }, val.classificationName);
        });

        props.func(data);
      } else {
        props.func([]);
      }
    } catch (error) {
      console.log("getGroupsList error=", error);

      props.func([]);
    }
  };

  const getTenantDevicesCnt = async (whereCondition: object) => {
    try {
      const { status, data } = await apiCall('/census/getCensusCount', whereCondition);

      if (status === 'success' && data?.totalRecords > 0) {
        props.setDeviceCnt(data.totalRecords);
      } else {
        props.setDeviceCnt(0);
      }
    } catch (error) {
      console.log("getCensusListsCnt error=", error);

      props.setDeviceCnt(0);
    }
  }

  const getGroupedDeviceCnt = async (whereCondition: any, name: string) => {
    try {
      const { status, data } = await apiCall(`/groups/getDeviceCount`, whereCondition);

      if (status === 'success' && data?.length > 0) {
        props.setGroupDeviceCnt((prev: any) => ({
          ...prev,
          [`${name}`]: data?.length,
        }));
      } else {
        props.setGroupDeviceCnt((prev: any) => ({
          ...prev,
          [`${name}`]: 0,
        }));
      }
    } catch (error) {
      console.log("getGroupedDevicesCnt error=", error);

      props.setGroupDeviceCnt((prev: any) => ({
        ...prev,
        [`${name}`]: 0,
      }));
    }
  }

  const getExportData = async (condition: object) => {
    try {
      const { status, data } = await apiCall(`/groups/getList`, condition);

      if (status === 'success') {
        props.setExportDetails && props.setExportDetails(data);
      }

      setTimeout(() => {
        props.setExportBtnClicked(false);
      }, 2000);
    } catch (error) {
      console.log("remediation assignment getExportData error=", error);

      props.setExportBtnClicked(false);
    }

  }

  const setPolicy_Patch = async () => {
    // const { data } = await client.mutate({
    //   mutation: setPolicyPatch,
    //   variables: {policyid, props.dartNo}, //also i am passing varvalue in place of dart no. for compliace policy in same variable
    //   fetchPolicy: 'network-only',
    // });

    // if(data){
    //   console.log("successful set of policy data");
    // }
  }

  if (props.policyPatch) {
    setPolicy_Patch();
    props.setPolicyPatch(false);
  }

  if (props.searchVal?.length > 0 && props.searchVal !== '') {
    getGroupsList({ tenant: props.tenant, function: 'search', search: props.searchVal }, 50, props.pageNo);

    getGroupsListCnt({ tenant: props.tenant, function: 'search', search: props.searchVal }, props.setTotalRecords, props.setTotalPages);
  } else if (props.isRefresh) {
    props.setRefresh(false);
    props.setRefreshToast(true);
    setTimeout(() => {
      props.setRefreshToast(false);
    }, 3000);
  } else if (props.exportBtnClicked) {
    getExportData({ function: 'export', tenant: props.tenant });
  } else {
    getGroupsList({ tenant: props.tenant }, 50, props.pageNo);
    getGroupsListCnt({ tenant: props.tenant }, props.setTotalRecords, props.setTotalPages);
  }
}

export { Remediations_func }